import StuffToEatList from './entities/stuff-to-eat-list';
import StuffToEatImages from './entities/stuff-to-eat-images';
import StuffToEatDetails from './entities/stuff-to-eat-details';
import StuffToEatContent from './entities/stuff-to-eat-content';
import StuffToEatContents from './entities/stuff-to-eat-contents';
import StuffToEatExchange from './entities/stuff-to-eat-exchange';
import StuffToEatMakeCopy from './entities/stuff-to-eat-make-copy';
import StuffToEatExchanges from './entities/stuff-to-eat-exchanges';
import StuffToEatCategories from './entities/stuff-to-eat-categories';
import StuffToEatInstruction from './entities/stuff-to-eat-instruction';
import StuffToEatServingSize from './entities/stuff-to-eat-serving-size';
import StuffToEatInstructions from './entities/stuff-to-eat-instructions';
import StuffToEatServingSizes from './entities/stuff-to-eat-serving-sizes';
import StuffToEatTypeCategories from './entities/stuff-to-eat-type-categories';
import StuffToEatNutritionFacts from './entities/stuff-to-eat-nutrition-facts';
import StuffToEatNutritionPrediction from './entities/stuff-to-eat-nutrition-prediction';
import StuffToEatNutritionFactsLabel from './entities/stuff-to-eat-nutrition-facts-label';
import StuffToEatNutritionInformation from './entities/stuff-to-eat-nutrition-information';
import StuffToEatAllergens from './entities/stuff-to-eat-allergens';
import StuffToEatNutritionFactsPrintLabel from './entities/stuff-to-eat-nutrition-facts-print-label';

export default {
  modules: {
    StuffToEatList,
    StuffToEatImages,
    StuffToEatDetails,
    StuffToEatContent,
    StuffToEatContents,
    StuffToEatExchange,
    StuffToEatMakeCopy,
    StuffToEatExchanges,
    StuffToEatCategories,
    StuffToEatServingSize,
    StuffToEatInstruction,
    StuffToEatServingSizes,
    StuffToEatInstructions,
    StuffToEatTypeCategories,
    StuffToEatNutritionFacts,
    StuffToEatNutritionFactsLabel,
    StuffToEatNutritionPrediction,
    StuffToEatNutritionInformation,
    StuffToEatAllergens,
    StuffToEatNutritionFactsPrintLabel,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-eat/index.js